function getXmlHttp() {
  var xmlhttp;
  try {
    // eslint-disable-next-line no-undef
    xmlhttp = new ActiveXObject('Msxml2.XMLHTTP');
  } catch (e) {
    try {
      // eslint-disable-next-line no-undef
      xmlhttp = new ActiveXObject('Microsoft.XMLHTTP');
    } catch (E) {
      xmlhttp = false;
    }
  }
  if (!xmlhttp && typeof XMLHttpRequest != 'undefined') {
    xmlhttp = new XMLHttpRequest();
  }
  return xmlhttp;
}

const createRedmineHelpdeskWidget = (elementId, redmineUrl, callback) => {
  let widget
  let button
  let loading_div
  let iframe
  let avatar
  let animation_css
  let widget_css
  let script
  let close_button
  let styles_css
  let title_div
  let flash_div
  let container_div
  let custom_div
  let submit_div
  let project_id
  let tracker_id
  let field
  let option
  let options
  let attach_div
  let attach_link
  let attach_field
  let displayed_name
  let custom_field
  let button_margin
  let data

  let RedmineHelpdeskWidget = {
    widget: document.getElementById(elementId),
    widget_button: null,
    loading_div: null,
    full_screen: window.outerWidth <= 500 && window.outerHeight <= 700,
    width: 400,
    height: 500,
    margin: 20,
    button_size: 54,
    iframe: null,
    loaded: false,
    form: null,
    schema: null,
    reload: false,
    configuration: {},
    attachment: null,
    base_url: redmineUrl,
    px: function (number) {
      return number + 'px';
    },
    config: function (configuration) {
      this.configuration = configuration;
      this.apply_config();
    },
    apply_config: function () {
      this.apply_avatar();
      if (this.configuration['color']) {
        this.widget_button.style.backgroundColor = this.configuration['color'];
        this.loading_div.style.borderTop = '8px solid ' + this.configuration['color'];
      }
      if (this.configuration['icon']) {
        this.widget_button.innerHTML = this.configuration['icon'];
      }
      switch (this.configuration['position']) {
        case 'topLeft':
          this.widget.style.top = this.px(this.margin);
          this.widget.style.left = this.px(this.margin);
          break;
        case 'topRight':
          this.widget.style.top = this.px(this.margin);
          this.widget.style.right = this.px(this.margin);
          break;
        case 'bottomLeft':
          this.widget.style.bottom = this.px(this.margin);
          this.widget.style.left = this.px(this.margin);
          break;
        case 'bottomRight':
          this.widget.style.bottom = this.px(this.margin);
          this.widget.style.right = this.px(this.margin);
          break;
        default:
          widget.style.bottom = this.px(this.margin);
          widget.style.right = this.px(this.margin);
      }
    },
    translation: function (field) {
      return this.configuration['translation'] && this.configuration['translation'][field] ? this.configuration['translation'][field] : null;
    },
    identify: function (field) {
      return this.configuration['identify'] && this.configuration['identify'][field] ? this.configuration['identify'][field] : null
    },
    load: function () {
      this.create_widget_button();
      this.create_loading_div();
      this.decorate_widget_button();
      this.create_iframe();
      this.apply_animation();
      this.widget_button.addEventListener('click', function () {
        RedmineHelpdeskWidget.toggle()
      });
    },
    load_schema: function () {
      this.loading_div.style.display = 'block';
      this.widget_button.style.display = 'none';
      var xmlhttp = getXmlHttp();
      xmlhttp.open('GET', this.base_url + '/helpdesk_widget/load_form.json', true);
      xmlhttp.responseType = 'json';
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4) {
          if (xmlhttp.status === 200 || xmlhttp.status === 304) {
            RedmineHelpdeskWidget.schema = xmlhttp.response;
            RedmineHelpdeskWidget.fill_form();
            RedmineHelpdeskWidget.loaded = true;
            RedmineHelpdeskWidget.decorate_iframe();
          } else {
            RedmineHelpdeskWidget.schema = {};
            RedmineHelpdeskWidget.loaded = false;
          }
          RedmineHelpdeskWidget.loading_div.style.display = 'none';
          RedmineHelpdeskWidget.widget_button.style.display = 'block';
        }
      };
      xmlhttp.send(null);
    },
    create_widget_button: function () {
      button = document.createElement('div');
      button.id = 'widget_button';
      button.className = 'widget_button';
      button.innerHTML = '?';
      button.setAttribute('name', 'helpdesk_widget_button');
      button.style.backgroundColor = '#7E8387';
      button.style.backgroundSize = '15px 15px';
      button.style.cursor = 'pointer';
      button.style.color = 'white';
      button.style.textAlign = 'center';
      button.style.fontSize = '32px';
      button.style.verticalAlign = 'middle';
      button.style.lineHeight = this.px(this.button_size);
      button.style.minWidth = this.px(this.button_size);
      button.style.minHeight = this.px(this.button_size);
      button.style.borderRadius = '30px';
      button.style.zIndex = 'inherit';
      button.style.boxShadow = 'rgba(0, 0, 0, 0.258824) 0px 2px 5px 0px';
      button.style.webkitTransition = 'transform 0.2s ease';
      this.widget_button = button;
      this.widget.appendChild(button);
    },
    create_loading_div: function () {
      loading_div = document.createElement('div');
      loading_div.id = 'loading_div';
      loading_div.className = 'loading';
      loading_div.style.minWidth = this.px(this.button_size - 8);
      loading_div.style.minHeight = this.px(this.button_size - 8);
      loading_div.style.position = 'absolute';
      loading_div.style.display = 'none';
      loading_div.style.zIndex = 'inherit';
      this.loading_div = loading_div;
      this.widget.appendChild(loading_div);
    },
    decorate_widget_button: function () {
      widget = this.widget;
      widget.style.position = 'fixed';
      widget.style.bottom = '20px';
      widget.style.right = '20px';
      widget.style.width = this.px(this.button_size);
      widget.style.height = this.px(this.button_size);
      widget.style.zIndex = 9999;
      widget.style.display = 'flex';
      widget.style.justifyContent = 'flex-start';
      widget.style.alignItems = 'center';
    },
    create_iframe: function () {
      this.iframe = document.createElement('iframe');
      this.iframe.style.opacity = '0';
      this.widget.appendChild(this.iframe);

      this.iframe.onload = function () {
        RedmineHelpdeskWidget.decorate_iframe();
      }
    },
    decorate_iframe: function () {
      this.append_stylesheets();
      iframe = this.iframe;
      iframe.setAttribute('id', 'helpdesk_ticket_container');
      iframe.setAttribute('frameborder', 0);
      iframe.style.position = 'absolute';
      iframe.style.opacity = '0';
      iframe.style.minWidth = this.full_screen ? '100vw' : this.px(this.width);
      iframe.style.minHeight = this.full_screen ? '100vh' : this.px(this.height);
      iframe.style.maxWidth = 'initial';
      iframe.style.backgroundColor = 'white';
      iframe.style.top = 0;
      iframe.style.webkitTransition = 'top 0.5s, opacity 0.1s';
      iframe.style.transition = 'top 0.5s, opacity 0.1s';
      iframe.style.boxShadow = 'rgba(0, 0, 0, 0.258824) 0px 1px 4px 0px';
      iframe.setAttribute('name', 'helpdesk_widget_iframe');
    },
    appendToIframe: function (element) {
      this.iframe.contentWindow.document.body.appendChild(element)
    },
    fill_form: function () {
      if (Object.keys(this.schema.projects).length > 0) {
        this.create_form();
        this.create_form_close_button();
        this.create_form_title();
        this.create_error_flash();

        if (this.identify('redmineUserID')) {
          this.create_form_hidden(this.form, 'redmine_user', 'redmine_user', 'form-control', this.identify('redmineUserID'));
        }
        if (this.identify('nameValue')) {
          this.create_form_hidden(this.form, 'username', 'username', 'form-control', this.identify('nameValue'));
        } else {
          this.create_form_text(this.form, 'username', 'username', this.translation('nameLabel') || 'Your name', 'form-control', this.identify('nameValue'), true);
        }
        if (this.identify('emailValue')) {
          this.create_form_hidden(this.form, 'email', 'email', 'form-control', this.identify('emailValue'));
        } else {
          this.create_form_text(this.form, 'email', 'email', this.translation('emailLabel') || 'Email address', 'form-control', this.identify('emailValue'), true);
        }
        if (this.identify('subjectValue')) {
          this.create_form_hidden(this.form, 'subject', 'issue[subject]', 'form-control', this.identify('subjectValue'));
        } else {
          this.create_form_text(this.form, 'subject', 'issue[subject]', this.translation('subjectLabel') || 'Subject', 'form-control', this.identify('subjectValue'), true);
        }
        if (this.identify('issueCategory')) {
          this.create_form_hidden(this.form, 'issue_category', 'issue_category', 'form-control', this.identify('issueCategory'));
        }
        this.create_projects_selector();
        this.create_form_area(this.form, 'description', 'issue[description]', this.translation('descriptionLabel') || 'Ticket description', 'form-control', true);

        var project_id = null;
        var tracker_id = null;
        if (RedmineHelpdeskWidget.configuration['identify']) {
          project_id = RedmineHelpdeskWidget.schema.projects[RedmineHelpdeskWidget.configuration['identify']['projectValue']];
          if (project_id) {
            tracker_id = RedmineHelpdeskWidget.schema.projects_data[project_id].trackers[RedmineHelpdeskWidget.configuration['identify']['trackerValue']];
          }
        }

        this.load_project_data(project_id || this.schema.projects[Object.keys(this.schema.projects)[0]], tracker_id);
        setTimeout(function () {
          RedmineHelpdeskWidget.appendToIframe(RedmineHelpdeskWidget.form)
        }, 1);
        this.append_scripts();
        this.create_message_listener();
      } else {
        this.widget.style.opacity = 0;
      }
    },
    apply_avatar: function () {
      button = document.getElementById('widget_button');
      avatar = RedmineHelpdeskWidget.configuration['user_avatar'];
      if (avatar && avatar.length > 0) {
        var xmlhttp = getXmlHttp();
        xmlhttp.open('GET', RedmineHelpdeskWidget.base_url + '/helpdesk_widget/avatar/' + avatar, true);
        xmlhttp.onreadystatechange = function () {
          if (xmlhttp.readyState === 4) {
            if (xmlhttp.status === 200 || xmlhttp.status === 304) {
              button.style.backgroundSize = 'cover';
              button.style.backgroundImage = 'url(' + RedmineHelpdeskWidget.base_url + '/helpdesk_widget/avatar/' + avatar + ')';
              button.style.border = '2px solid';
              button.innerHTML = '&nbsp;';
            } else {
              button.style.backgroundSize = '15px 15px';
              button.innerHTML = '?';
            }
            button.style.display = 'block';
            button.style.lineHeight = '50px';
          }
        };
        xmlhttp.send(null);
      } else {
        button.style.lineHeight = '54px';
        button.style.backgroundSize = '15px 15px';
        button.innerHTML = '?';
        button.style.display = 'block';
      }
    },
    apply_animation: function () {
      animation_css = document.createElement('link');
      animation_css.href = this.base_url + '/helpdesk_widget/animation.css';
      animation_css.rel = 'stylesheet';
      animation_css.type = 'text/css';

      document.head.appendChild(animation_css);
    },
    append_stylesheets: function () {
      widget_css = document.createElement('link');
      widget_css.href = this.base_url + '/helpdesk_widget/widget.css';
      widget_css.rel = 'stylesheet';
      widget_css.type = 'text/css';
      this.iframe.contentWindow.document.head.appendChild(widget_css);
      if (this.configuration['styles']) {
        styles_css = document.createElement('style');
        styles_css.innerHTML = this.configuration['styles'];
        styles_css.type = 'text/css';
        this.iframe.contentWindow.document.head.appendChild(styles_css);
      }
    },
    append_scripts: function () {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = this.base_url + '/helpdesk_widget/iframe.js';
      this.iframe.contentWindow.document.head.appendChild(script);
      this.iframe.contentWindow.postMessage(JSON.stringify({
        action: 'configuration',
        configuration: JSON.stringify(this.configuration)
      }), '*');
    },
    create_form: function () {
      this.form = document.createElement('form');
      this.form.action = this.base_url + '/helpdesk_widget/create_ticket';
      this.form.acceptCharset = 'UTF-8';
      this.form.method = 'post';
      this.form.id = 'widget_form';
      this.form.style.marginBottom = 0;
    },
    create_form_close_button: function () {
      close_button = document.createElement('div');
      close_button.id = 'closeButton'
      close_button.className = 'close-button';
      close_button.style.position = 'absolute';
      close_button.style.top = 0;
      close_button.style.right = 0;
      close_button.style.width = '40px';
      close_button.style.height = '40px';
      close_button.addEventListener('click', function () {
        RedmineHelpdeskWidget.toggle()
      });

      this.form.appendChild(close_button);
    },
    create_form_title: function () {
      if (this.configuration['title']) {
        title_div = document.createElement('div');
        title_div.id = 'title';
        title_div.className = 'title';
        title_div.innerHTML = this.configuration['title'];
        this.form.appendChild(title_div);
      }
    },
    create_error_flash: function () {
      flash_div = document.createElement('div');
      flash_div.id = 'flash';
      flash_div.className = 'flash';
      flash_div.style.marginTop = '20px';
      this.form.appendChild(flash_div);
    },
    create_projects_selector: function () {
      var project_id = null;
      if (RedmineHelpdeskWidget.configuration['identify']) {
        project_id = RedmineHelpdeskWidget.schema.projects[RedmineHelpdeskWidget.configuration['identify']['projectValue']];
      }
      if (project_id) {
        this.create_form_hidden(this.form, 'project_id', 'project_id', 'form-control projects', project_id);
      } else {
        this.create_form_select(this.form, 'project_id', 'project_id', RedmineHelpdeskWidget.schema.projects, project_id, 'form-control projects');
      }
    },
    load_project_data: function (project_id, tracker_id) {
      container_div = this.form.getElementsByClassName('container')[0]
      if (container_div) {
        container_div.remove()
      }

      container_div = document.createElement('div');
      container_div.id = 'container';
      container_div.className = 'container';

      custom_div = document.createElement('div');
      custom_div.id = 'custom_fields';
      custom_div.className = 'custom_fields';

      submit_div = document.createElement('div');
      submit_div.id = 'submit_button';
      submit_div.className = 'submit_button';

      container_div.appendChild(custom_div);

      this.create_form_privacy_policy(container_div);

      container_div.appendChild(submit_div);

      if (RedmineHelpdeskWidget.configuration['identify'] && RedmineHelpdeskWidget.schema.projects_data[project_id].trackers[RedmineHelpdeskWidget.configuration['identify']['trackerValue']]) {
        tracker_id = RedmineHelpdeskWidget.schema.projects_data[project_id].trackers[RedmineHelpdeskWidget.configuration['identify']['trackerValue']]
        this.create_form_hidden(custom_div, 'tracker_id', 'tracker_id', 'form-control trackers', tracker_id);
      } else {
        this.create_form_select(custom_div, 'tracker_id', 'tracker_id', this.schema.projects_data[project_id].trackers, tracker_id, 'form-control trackers');
        tracker_id = custom_div.getElementsByClassName('trackers')[0].value;
      }
      this.load_custom_fields(custom_div, project_id, tracker_id);

      this.create_form_submit(submit_div, this.translation('createButtonLabel') || 'Create ticket');
      this.create_attch_link(submit_div);

      this.form.appendChild(container_div);
    },
    reload_project_data: function () {
      project_id = this.form.getElementsByClassName('projects')[0].value;
      tracker_id = container_div.getElementsByClassName('trackers')[0].value;

      this.load_project_data(project_id, tracker_id);
      this.arrange_iframe();
    },
    create_form_select: function (target, field_id, field_name, values, selected, field_class) {

      if (Object.keys(values).length === 1) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.id = field_id;
        field.name = field_name;
        field.className = field_class + ' reloadProjectField';
        field.value = values[Object.keys(values)[0]];
      } else {
        field = document.createElement('select');
        field.id = field_id;
        field.name = field_name;
        field.className = field_class + ' reloadProjectField';
        for (var project in values) {
          option = document.createElement('option');
          option.value = values[project]
          if (values[project] === selected) {
            option.selected = 'selected';
          }
          option.innerHTML = project;
          field.appendChild(option);
        }
      }
      target.appendChild(field);
    },
    create_form_hidden: function (target, field_id, field_name, field_class, value) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.id = field_id;
      field.name = field_name;
      field.value = value;
      field.className = field_class;
      target.appendChild(field);
    },
    create_form_text: function (target, field_id, field_name, field_placeholder, field_class, value, required) {
      field = document.createElement('input');
      field.type = 'text';
      field.id = field_id;
      field.name = field_name;
      field.value = value;
      field.placeholder = field_placeholder;
      field.className = required ? field_class + ' required-field' : field_class;
      target.appendChild(field);
    },
    create_form_area: function (target, field_id, field_name, field_placeholder, field_class, required) {
      field = document.createElement('textarea');
      field.cols = 55;
      field.rows = 10;
      field.id = field_id;
      field.name = field_name;
      field.placeholder = field_placeholder;
      field.className = required ? field_class + ' required-field' : field_class;
      target.appendChild(field);
    },
    create_form_submit: function (target, label) {
      field = document.createElement('input');
      field.id = 'form-submit-btn';
      field.type = 'submit';
      field.name = 'submit';
      field.className = 'btn';
      field.value = label;
      field.title = this.translation('buttomLabel') || '';
      if (RedmineHelpdeskWidget.configuration['color']) {
        field.style.background = RedmineHelpdeskWidget.configuration['color'];
      }
      target.appendChild(field);
    },
    create_form_privacy_policy: function (target) {
      var privacy_policy_div = document.createElement('div');
      privacy_policy_div.id = 'privacy_policy_fields';
      privacy_policy_div.className = 'privacy_policy_fields';

      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.id = 'privacy_policy';
      checkbox.name = 'privacy_policy';
      checkbox.value = 1;
      checkbox.required = 'required';

      var checkbox_label = document.createElement('label');
      checkbox_label.htmlFor = checkbox.id;
      // slice(3, -4) for removing wrapper <p>...</p>
      checkbox_label.innerHTML = '<p>Eu concordo com a <a target="_blank" href="https://brobot.com.br/politica_de_privacidade/" class="external" rel="noopener">política de privacidade</a>.</p>'.slice(3, -4);

      var links = checkbox_label.getElementsByTagName('a');
      for (var i = 0, len = links.length; i < len; i++) {
        links[i].target = '_blank'
      }

      privacy_policy_div.appendChild(checkbox);
      privacy_policy_div.appendChild(checkbox_label);
      target.appendChild(privacy_policy_div);
    },
    create_attch_link: function (target) {
      if (this.configuration['attachment'] != false) {
        attach_div = document.createElement('div');
        attach_div.className = 'attach_div';

        attach_link = document.createElement('a');
        attach_link.className = 'attach_link';
        attach_link.href = 'javascript:void(0)';
        attach_link.innerHTML = this.translation('attachmentLinkLabel') || 'Attach a file';
        attach_div.appendChild(attach_link);

        attach_field = document.createElement('input');
        attach_field.type = 'file';
        attach_field.id = 'attachment';
        attach_field.className = 'attach_field';
        attach_field.name = 'attachment';
        attach_field.attributes['data-max-size'] = 5242880;
        attach_field.addEventListener('change', function () {
          RedmineHelpdeskWidget.upload_file()
        });
        attach_div.appendChild(attach_field);
        this.attachment = attach_field;

        target.appendChild(attach_div);
      }
    },
    upload_file: function () {
      if (this.attachment.attributes['data-max-size'] > this.attachment.files[0].size) {
        this.read_file(this.attachment.files[0], function (e) {
          attach_field = RedmineHelpdeskWidget.form.getElementsByClassName('attach_field')[0]
          attach_field.attributes['data-value'] = e.target.result;
          displayed_name = (attach_field.files[0].name.length <= 20) ? attach_field.files[0].name : attach_field.files[0].name.substring(0, 20) + '...';
          RedmineHelpdeskWidget.form.getElementsByClassName('attach_link')[0].innerHTML = displayed_name;
        });
      } else {
        this.attachment.attributes['data-value'] = '';
        RedmineHelpdeskWidget.form.getElementsByClassName('attach_link')[0].innerHTML = 'Sorry, too large';
      }
    },
    read_file: function (file, callback) {
      var reader = new FileReader();
      reader.onload = callback
      reader.readAsDataURL(file);
    },
    load_custom_fields: function (target, project_id, tracker_id) {
      var xmlhttp = getXmlHttp();
      var params = 'project_id=' + encodeURIComponent(project_id) + '&tracker_id=' + encodeURIComponent(tracker_id);
      custom_div = document.createElement('div');
      xmlhttp.open('GET', this.base_url + '/helpdesk_widget/load_custom_fields?' + params, true);
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4) {
          if (xmlhttp.status === 200 || xmlhttp.status === 304) {
            custom_div.innerHTML = xmlhttp.responseText;
            target.appendChild(custom_div);
            RedmineHelpdeskWidget.set_custom_values();
            setTimeout(function () {
              RedmineHelpdeskWidget.arrange_iframe()
            }, 100);
          }
        }
      };
      xmlhttp.send(null);
    },
    set_custom_values: function () {
      if (this.configuration['identify'] && this.configuration['identify']['customFieldValues']) {
        for (var cf in this.configuration['identify']['customFieldValues']) {
          custom_field = this.form.querySelector('#issue_custom_field_values_' + this.schema.custom_fields[cf])
          if (custom_field) {
            switch (custom_field.tagName) {
              case 'INPUT':
                custom_field.type = 'hidden';
                custom_field.value = this.configuration['identify']['customFieldValues'][cf];
                this.form.querySelector("[data-error-key='" + cf + "']").style.display = 'none';
                break;
              case 'SELECT':
                options = custom_field.options;
                for (var option, index = 0; option <= options[index]; index++) {
                  if (option.value === this.configuration['identify']['customFieldValues'][cf]) {
                    this.create_form_hidden(custom_field.parentElement, custom_field.id, custom_field.name, custom_field.classList.toString(), this.configuration['identify']['customFieldValues'][cf]);
                    custom_field.remove();
                    this.form.querySelector("[data-error-key='" + cf + "']").style.display = 'none';
                    break;
                  }
                }
                break;
            }
          }
        }
      }
    },
    arrange_iframe: function () {
      button_margin = this.margin + this.button_size;

      if (!this.full_screen) {
        this.iframe.style.minHeight = this.px(this.form.offsetHeight + this.margin);
      } else {
        this.iframe.style.paddingTop = this.px(button_margin + (button_margin / 3));
      }

      switch (this.configuration['position']) {
        case 'topLeft':
          this.iframe.style.top = this.full_screen ? this.px(-this.margin) : this.px(button_margin);
          iframe.style.left = this.full_screen ? this.px(-this.margin) : this.px(0);
          break;
        case 'topRight':
          this.iframe.style.top = this.full_screen ? this.px(-this.margin) : this.px(button_margin);
          iframe.style.left = this.full_screen ? this.px(-window.innerWidth + button_margin) : this.px(-this.width + this.button_size);
          break;
        case 'bottomLeft':
          this.iframe.style.top = this.full_screen ? this.px(-window.innerHeight + button_margin) : this.px(-this.form.offsetHeight - this.margin * 2);
          this.iframe.style.left = this.full_screen ? this.px(-this.margin) : this.px(0);
          break;
        case 'bottomRight':
          this.iframe.style.top = this.full_screen ? this.px(-window.innerHeight + button_margin) : this.px(-this.form.offsetHeight - this.margin * 2);
          iframe.style.left = this.full_screen ? this.px(-window.innerWidth + button_margin) : this.px(-this.width + this.button_size);
          break;
        default:
          this.iframe.style.top = this.full_screen ? this.px(-window.innerHeight + button_margin) : this.px(-this.form.offsetHeight - this.margin * 2);
          this.iframe.style.left = this.full_screen ? this.px(-window.innerWidth + button_margin) : this.px(-this.width + this.button_size);
      }
      this.iframe.style.opacity = '1';
    },
    create_message_listener: function () {
      var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
      var eventer = window[eventMethod];
      var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

      eventer(messageEvent, function (e) {
        try {
          data = JSON.parse(e.data);
        } catch (e) {
          return
        }

        if (data['reload'] === true) {
          RedmineHelpdeskWidget.reload_form();
        }
        if (data['project_reload'] === true) {
          RedmineHelpdeskWidget.reload_project_data();
        }
        if (data['arrange'] === true) {
          RedmineHelpdeskWidget.arrange_iframe();
        }
        if (data['close'] === true) {
          RedmineHelpdeskWidget.toggle();
        }
      }, false);
    },
    reload_form: function () {
      this.iframe.remove();
      this.create_iframe();
      this.fill_form();
      this.decorate_iframe();
      this.reload = false;
    },
    show: function () {
      if (this.loaded) this.arrange_iframe();
      switch (this.configuration['position']) {
        case 'topLeft':
        case 'topRight':
          this.widget_button.style.borderRadius = '50% 50% 0%';
          break;
        case 'bottomLeft':
        case 'bottomRight':
          this.widget_button.style.borderRadius = '0 100% 100%';
          break;
        default:
          this.widget_button.style.borderRadius = '0 100% 100%';
      }

      this.widget_button.style.webkitTransform = 'rotate(45deg)';
      this.widget_button.style.mozTransform = 'rotate(45deg)';
      this.widget_button.style.msTransform = 'rotate(45deg)';
      this.widget_button.style.oTransform = 'rotate(45deg)';
    },
    hide: function () {
      if (this.reload === true) {
        this.reload_form();
      }
      // eslint-disable-next-line no-unused-vars
      let body = this.iframe.contentWindow.document.body;
      this.iframe.style.opacity = 0;
      this.iframe.style.top = 0;
      this.widget_button.style.borderRadius = '30px';
      this.widget_button.style.webkitTransform = '';
      this.widget_button.style.mozTransform = '';
      this.widget_button.style.msTransform = '';
      this.widget_button.style.oTransform = '';
    },
    toggle: function () {
      if (!this.loaded)
        this.load_schema();

      parseInt(this.iframe.style.opacity) === 1 ? this.hide() : this.show();
    }
  }

  RedmineHelpdeskWidget.load();
  if (callback && typeof callback === 'function')
    callback(RedmineHelpdeskWidget)
}

export default createRedmineHelpdeskWidget